import React from "react";
import type { ReactNode } from "react";
import { Flex, Text } from "@jsq/ds/core";

export type PaymentDetailsModalFieldProps = {
  label: string;
  value?: string | number | ReactNode | null;
  gap?: number;
};
const PaymentDetailsModalField: React.FC<PaymentDetailsModalFieldProps> = (props) => {
  const { label, value, gap = 24 } = props;
  return (
    <Flex gap={gap} data-testid="PaymentDetailsModalField">
      <Flex flexBasis="60%" data-testid="PaymentDetailsModalFieldLabelFlex">
        <Text variant="secondary-md" data-testid="PaymentDetailsModalFieldLabelText">
          {label}
        </Text>
      </Flex>
      <Flex flexBasis="100%" data-testid="PaymentDetailsModalFieldValueFlex">
        <Text
          variant="regular-md"
          asSpan={!["number", "string"].includes(typeof value)}
          data-testid="PaymentDetailsModalFieldValueText"
        >
          {value}
        </Text>
      </Flex>
    </Flex>
  );
};

export default PaymentDetailsModalField;
